import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';


import { cn } from '../../libraries/tailwind/utils';
import Icon from '../renders/icon/Icon';
import ICONS from '../../enums/icons';
import PropTypes from 'prop-types';

const Checkbox = React.forwardRef(({ className, iconClassName = '', ...props }, ref) => (
    <CheckboxPrimitive.Root
        ref={ref}
        className={cn(
            // eslint-disable-next-line max-len
            'peer h-5 w-5 shrink-0 rounded-sm border border-gray-400 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground',
            className
        )}
        {...props}>
        <CheckboxPrimitive.Indicator
            className={cn('flex items-center justify-center text-current h-4')}
        >
            <Icon icon={ICONS.OK} className={iconClassName} />
        </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

Checkbox.propTypes = {
    className: PropTypes.string,
    iconClassName: PropTypes.string
};

export default Checkbox;
